// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
import { isPhoneNumberDigits } from '../../../utils';

// INNER IMPORTS
import './main-styles.css';
import './contactbasic.css';

const ContactBasic = ({ type, phone, email, fblink, updateValue }) => {
    const validatePhone = (event) => {
        if (!isPhoneNumberDigits(event.target.value) && event.target.value.length > 0) return;
        if (event.target.value.length > 15) return;
        updateValue(event);
    };

    // Contact with fans
    // Contact info
    return (
        <div className="contact-basic-wrapper rtl input-wrapper">
            <div className={"title " + type}>{type === 'liveMusic' ? 'תתחברו עם מעריצים' : 'פרטים ליצירת קשר'}</div>

            <div className="input-wrapper">
                <input
                    type="phone"
                    min="0"
                    name="phone"
                    placeholder="טלפון?"
                    onChange={(event) => validatePhone(event)}
                    value={phone}
                />

                <input
                    type="text"
                    name="email"
                    placeholder="מייל?"
                    onChange={updateValue}
                    value={email}
                />
            </div>

            <div className="input-wrapper">
                <input
                    type="text"
                    name="fblink"
                    placeholder="לינק לפרופיל פייסבוק"
                    onChange={updateValue}
                    value={fblink}
                />
            </div>
        </div>
    )
};

ContactBasic.propTypes = {
    type: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    fblink: PropTypes.string,
    updateValue: PropTypes.func.isRequired
};

export default ContactBasic;



// WEBPACK FOOTER //
// ./src/Components/Elements/Inputs/ContactBasic.js